<template>
  <div class="backconrtM">
    <div class="camera">
      <div class="cameraClick" @click="openCamera"></div>
    </div>
    <div class="backCourt-em">
      <div class="emCon">
        <el-carousel
          indicator-position="none"
          height="100%"
          direction="vertical"
        >
          <el-carousel-item>
            <div>PM2.5</div>
            <div>{{ Environmental.pm25 ? Environmental.pm25 : "" }}μg/m³</div>
          </el-carousel-item>
          <el-carousel-item>
            <div>PM1.0</div>
            <div>{{ Environmental.pm10 ? Environmental.pm10 : "" }}μg/m³</div>
          </el-carousel-item>
          <el-carousel-item>
            <div>温度</div>
            <div>
              {{
                Environmental.envTemperature
                  ? Environmental.envTemperature.toFixed(2)
                  : ""
              }}°C
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div>湿度</div>
            <div>
              {{
                Environmental.envHumidity
                  ? Environmental.envHumidity.toFixed(1)
                  : ""
              }}hPa
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div>气压</div>
            <div>
              {{
                Environmental.airPressure
                  ? Environmental.airPressure.toFixed(2)
                  : ""
              }}Pa
            </div>
          </el-carousel-item>
          <!-- <el-carousel-item>
            <div>光照度</div>
            <div>{{Environmental.illuminance?Environmental.illuminance.toFixed(2):''}}μg/m³</div>
          </el-carousel-item> -->
          <!-- <el-carousel-item>
            <div>噪声</div>
            <div>{{Environmental.noise?Environmental.noise:''}}μg/m³</div>
          </el-carousel-item> -->
          <el-carousel-item v-if="Environmental.windDirection&&Environmental.windDirection.indexOf('?') ==-1 ">
            <div>风向</div>
            <div>
              {{
                Environmental.windDirection ? Environmental.windDirection : ""
              }}
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div>风速</div>
            <div>
              {{
                Environmental.windSpeed
                  ? Environmental.windSpeed.toFixed(2)
                  : ""
              }}mps
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div>风力</div>
            <div>
              {{ Environmental.windPower ? Environmental.windPower : "" }}级
            </div>
          </el-carousel-item>
          <!-- <el-carousel-item>
            <div>喷淋状态</div>
            <div>{{Environmental.status?Environmental.status:''}}</div>
          </el-carousel-item> -->
        </el-carousel>
      </div>
    </div>
    <div class="italics">
      <div class="italicsTitle">
        {{ mixName ? mixName : "暂无拌合楼生产" }}
      </div>
      <el-row>
        <el-col :span="12" style="width:45%">
          <div>
            累计拌和<span> {{ Mixing }}</span>
            <!-- 累计拌和<span> 1228.2t</span> -->
          </div>
        </el-col>
        <el-col :span="12" style="width:55%">
          <div>
            单位小时产量<span> {{ yieldW }}</span>
            <!-- 单位小时产量<span> 421.1t</span> -->
          </div>
        </el-col>
        <template v-if="isType == 'lq'">
          <el-col :span="12" style="width:48%">
            <div>
              油石比均值<span> {{ meanValue }}</span>
            </div>
          </el-col>
        </template>
        <template v-else>
          <el-col :span="12">
            <div>
              水泥含量均值<span> {{ meanValue }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              水泥含量合格率<span> {{ Ratio }}</span>
            </div>
          </el-col>
        </template>
        <el-col :span="12" v-if="isType == 'lq'" style="width:52%">
          <div>
            油石比合格率<span> {{ OilRatio }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="transportWave">
      <div class="Wave1">
        在途料车<span>{{ onTheWay ? onTheWay : "-/-" }}</span>
        <!-- 在途料车<span>5</span> -->
      </div>
      <div class="Wave2">
        运输车数量<span>{{ transportNum ? transportNum : "-/-" }}</span>
         <!-- 运输车数量<span>16</span> -->
      </div>
      <div class="Wave3">
        运输总车次<span>{{ transportTotal ? transportTotal : "-/-" }}</span>
        <!-- 运输总车次<span>17</span> -->
      </div>
      <div class="Wave4">
        平均运输时间<span>{{
          transportAverage || transportAverage == 0
            ? transportAverage + "min"
            : "-/-"
        }}</span>
         <!-- 平均运输时间<span>45min</span> -->
      </div>
      <div class="Wave5">
        运输时间异常<span>{{
          timeAbnormal ? timeAbnormal + "车料" + "(" + percentage + "%)" : "-/-"
        }}</span>
        <!-- 运输时间异常<span>0</span> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  getKeyLabel,
  getCement,
  getQuantityOfTrucks,
  getSummarizingInfo,
  getCurrentTime,
  getInitScreenData,
  getRealChannel
} from "@/api/api";
export default {
  props: {
    type: "",
  },
  data() {
    return {
      currentDate: "",
      currentTime: "",
      isType: "",
      // 后场
      Mixing: "",
      yieldW: "",
      meanValue: "",
      OilRatio: "",
      Ratio:'',
      // 运输
      onTheWay: "",
      transportNum: "",
      transportTotal: "",
      transportAverage: "",
      timeAbnormal: "",
      percentage: "",
      mixName: "",
      Environmental: {},
      isOpen: false,
    };
  },
  created() {
    this.dataRefreh();
  },
  mounted() {
    this.isType = this.type;
    const timeMachine = getCurrentTime();
    this.currentDate = timeMachine.split(" ")[0];
    this.currentTime = timeMachine.split(" ")[1];
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    // 定时刷新数据函数
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        this.getOnTheWay();
        this.getTotalCar();
      }, 30000);
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId); //清除计时器
      this.intervalId = null; //设置为null
    },
    // 获取后场信息
    async getkeyLabels() {
      this.mixName = this.mixplantName;
      let req = {
        endDate: this.currentDate,
        mixplantId: this.mixplantId,
        sectionId: this.seIds,
        startDate: this.currentDate,
        workAreaId: this.sectionId,
      };
        const mpDataLQ = await getKeyLabel(this.type,req);
        console.log(mpDataLQ)
        this.Mixing = mpDataLQ.data.weight?mpDataLQ.data.weight+' t':'-/-';
        this.yieldW = mpDataLQ.data.perHourWeight?mpDataLQ.data.perHourWeight+'t/h':'-/-';
        if(this.type == 'lq') {
          this.meanValue = mpDataLQ.data.oilYieldAvg?(mpDataLQ.data.oilYieldAvg.toFixed(2)*100)+'%':'-/-';
        }
        this.OilRatio = mpDataLQ.data.oilYield?mpDataLQ.data.oilYield+'%':'-/-';
    },
    // 获取后场信息均值合格率
    async getCements() {
      this.mixName = this.mixplantName;
      let req = {
        endDate: this.currentDate,
        mixplantId: this.mixplantId,
        sectionId: this.seIds,
        startDate: this.currentDate,
        workAreaId: this.sectionId,
      };
        const cementLQ = await getCement(this.type,req);
        console.log(cementLQ)
        this.meanValue = cementLQ.data.collect.list.length > 0?cementLQ.data.collect.list[0].avgValue.toFixed(2)+'%':'-/-';
        this.Ratio = cementLQ.data.collect.list.length > 0?cementLQ.data.collect.list[0].yield+'%':'-/-';
    },
    // 开启监控
    async openCamera() {
      let req = {
        engineeringId: this.engineerId,
        workareaId:this.sectionId,
        site:2  //1前2后
      };
      // 前置获取是否有视频流返回
      const ertData = await getRealChannel(req);
      if(ertData.data.length!=0){
        this.isOpen = !this.isOpen
        this.$store.commit("updataMixplantOpen", this.isOpen)
      }else {
        this.$message({
          message: '暂无视频数据',
          type: 'warning'
        });
      }

    },
    async getEnvironmental() {
      let req = {
        // engineeringConfigId:this.engineerId
        engineeringConfigId: 1,
      };
      const ertData = await getInitScreenData(req);
      console.log(ertData.data)
      console.log(ertData.data.resultData)
      if (ertData.status == 200) {
        this.Environmental = ertData.data.resultData?ertData.data.resultData:{};
      }
    },
    // 获取在途运输车
    async getOnTheWay() {
      let req = {
        mType: this.type,
        workAreaId: this.sectionId,
      };
      const otwData = await getQuantityOfTrucks(req);
      this.onTheWay = otwData.data.ways.length;
    },
    async getTotalCar() {
      let req = {
        endDate: this.currentDate,
        materialType: this.type,
        sectionId: this.seIds,
        startDate: this.currentDate,
        workAreaId: this.sectionId,
      };
      const tcData = await getSummarizingInfo(req);
      (this.transportNum = tcData.data.carCount),
        (this.transportTotal = tcData.data.transportCount),
        (this.transportAverage = tcData.data.avgTransportDuration),
        (this.timeAbnormal = tcData.data.overTimeCount),
        (this.percentage = tcData.data.upLimitRatio);
    },
    // 获取总车次
  },
  computed: mapState([
    "engineerId",
    "sectionId",
    "workAreaId",
    "mixplantId",
    "mixplantName",
    "seIds"
  ]),
  watch: {
    isType(curVal, oldVal) {
      this.getEnvironmental();
    },
    engineerId(curVal, oldVal) {
      this.getEnvironmental();
    },
    sectionId(curVal, oldVal) {},
    workAreaId(curVal, oldVal) {
      this.getkeyLabels();
      if(this.isType != 'lq') {
        this.getCements()

      }

      this.getOnTheWay();
      this.getTotalCar();
    },
    mixplantId(curVal, oldVal) {
      this.getkeyLabels();
      if(this.isType != 'lq') {
        this.getCements()

      }
    },
  },
};
</script>

<style lang="less" scoped>
.backconrtM {
  position: absolute;
  width: 100%;
  height: 100%;
  .camera {
    position: absolute;
    left: 600px;
    margin-top: 40px;
    width: 33px;
    height: 231px;
    background-image: url(../assets/img/backCourt-monitor@2x.png);
    background-size: 100% 100%;
    .cameraClick {
      position: absolute;
      top: 0;
      width: 33px;
      height: 40px;
    }
  }
  .backCourt-em {
    position: absolute;
    left: 650px;
    margin-top: 64px;
    width: 67px;
    height: 156px;
    background-image: url(../assets/img/backCourt-em@2x.png);
    background-size: 100% 100%;
    .emCon {
      width: 60px;
      height: 30px;
      margin-top: 42px;
      font-size: 10px;
      margin-left: 2px;
      text-align: center;
      transform: rotate(8deg);
      color: #fd3b4f;
      // overflow: hidden;
      .el-carousel {
        height: 100%;
      }
    }
  }
  .italics {
    position: absolute;
    bottom: 180px;
    left: 20px;
    width: 300px;
    height: 90px;
    text-align: center;
    transform: skewX(-4deg) rotate(9deg);
    .el-row {
      height: 30%;
      color: #fffefe;
      font-weight: bold;
      .el-col-12 {
        height: 100%;
        div {
          line-height: 24px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          span {
            color: #fff721;
          }
        }
      }
      .el-col-24 {
        text-align-last: left;
        padding-left: 25px;
        font-size: 14px;
        span {
            color: #fff721;
          }
      }
    }
    .italicsTitle {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #fffefe;
    }
  }
  .transportWave {
    position: absolute;
    right: 0;
    bottom: 50px;
    z-index: inherit;
    width: 800px;
    height: 60px;
    div {
      float: left;
      font-size: 14px;
      color: #fff;

      span {
        display: inline-block;
        margin-left: 10px;
        color: #fff721;
        font-weight: 700;
      }
    }
  }
  .Wave1 {
    position: absolute;
    top: -100px;
    left: 54px;
    transform: rotate(-12deg);
  }
  .Wave2 {
    position: absolute;
    top: -140px;
    left: 170px;
    transform: rotate(-22deg);
  }
  .Wave3 {
    position: absolute;
    top: -206px;
    left: 290px;
    transform: rotate(-30deg);
  }
  .Wave4 {
    position: absolute;
    top: -265px;
    left: 406px;
    transform: rotate(-20deg);
    span {
      position: absolute;
      top: 7px;
      transform: rotate(12deg);
    }
  }
  .Wave5 {
    position: absolute;
    top: -294px;
    right: 140px;
    span {
      position: absolute;
      top: 4px;
      width: 100px;
      transform: rotate(6deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/subassembly/backconrt.vue